import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { TableSortModel } from '../../tablesort/tableSortModel';
import { ListLoader } from '../../components/list-loader/list-loader';
import { GeometergeschaeftListEntryMeta } from '../../../core/av-api';
import { AbstractComponent } from '../../components/abstract-component/abstract.component';
import { ComparatorService } from '../../services/comparator-service';
import { ListLoaderWrapperComponent } from '../../components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { ColumnHeaderComponent } from '../../tablesort/sort-icon/column-header.component';
import { KompaktGeometergeschaeftComponent } from '../../kompaktdarstellung/geometergeschaeft/kompakt-geometergeschaeft.component';
import { TranslatePipe } from '@ngx-translate/core';
import { DatumPipe } from '../../pipes/simple/datum.pipe';
import { AppPermissionService } from '../../../core/services/app-permission.service';
import { ErweiterungConfigResponse } from '../../../core/base-api';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Component({
  selector: 'cap-geogeschaeft-table',
  templateUrl: './geogeschaeft-table.component.html',
  styleUrls: ['./geogeschaeft-table.component.scss'],
  imports: [
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    ColumnHeaderComponent,
    KompaktGeometergeschaeftComponent,
    TranslatePipe,
    DatumPipe
  ]
})
export class GeogeschaeftTableComponent extends AbstractComponent implements OnInit {
  @Input()
  showZeilenSelect = true;

  @Input()
  showTotal = true;

  canViewGeoGeschaeftDetails = false;
  tableSortModel = new TableSortModel<GeometergeschaeftListEntryMeta>('table', this.comparatorService);
  private _listLoader: ListLoader<GeometergeschaeftListEntryMeta>;
  private deploymentMode = (window as any).environment.deploymentMode;

  @Input()
  set listLoader(listLoader: ListLoader<GeometergeschaeftListEntryMeta>) {
    if (!listLoader) {
      return;
    }
    this._listLoader = listLoader;
    this._listLoader.applySortModel(this.tableSortModel);
  }

  get listLoader(): ListLoader<GeometergeschaeftListEntryMeta> {
    return this._listLoader;
  }

  constructor(
    protected router: Router,
    protected appformatConfigService: FormatConfigService,
    protected comparatorService: ComparatorService,
    private permissionService: AppPermissionService
  ) {
    super();
    keysToTranslate<string>([
      'KeineDatenVorhanden',
      'grundstueck.ListTitel',
      'PlanZuGrundstueckAnzeigen',
      'Kurzbeschreibung',
      'Datum Auftrag'
    ]);
    this.tableSortModel.addColumn('nummer').switchSortDirection();
    this.tableSortModel.addColumn('status');
    this.tableSortModel.addColumn('datumAuftrag');
    this.tableSortModel.addColumn('beschreibung');
  }

  ngOnInit(): void {
    let isErweiterungAvGeschaeftIntercapiActive: boolean = false;
    this.addSub(
      this.appformatConfigService.erweiterungsConfig$.subscribe((config) => {
        isErweiterungAvGeschaeftIntercapiActive = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.AV_GESCHAEFT_INTERCAPI);
      })
    );
    this.canViewGeoGeschaeftDetails =
      this.permissionService.hasPermission('GEOMETER_REGISTER') &&
      isErweiterungAvGeschaeftIntercapiActive &&
      this.deploymentMode !== 'PUBLIC';
  }
}
